import PerformanceStartupsComparator from './container';

export default PerformanceStartupsComparator;
